import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, ViewChild, OnDestroy, OnInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ModeratRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {EmbedService} from "../../services/embed.service";
import {FormGroup, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {DecimalPipe} from "@angular/common";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {SanierungIntroductionComponent} from "./sanierung-introduction.component";
import {StepNavigationComponent} from "../../step/step.navigation.component";
import {PortalService} from "../../services/portal.service";
import {StepNavigationElement} from "../../step/step.navigation.element";
import {WpcheckStartComponent} from "../wpcheck/wpcheck.start.component";
import {EnergyMapService} from '../../energy-map/services/energy.map.service';
import {CostChangesEmitter, FinanzierungsTyp, ResultDataCosts, ResultMeasure} from "../interfaces/result-data.interface";
import {Consumption} from "../interfaces/result-consumption";
import {find} from "rxjs/operators";
import {AdvisorEventService} from "../../services/advisor-event.service";
import {PortalTeaserComponent} from "../../teaser/portal.teaser.component";

/**
 *
 */
@Component({
    selector: 'app-moderat-sanierung',
    templateUrl: './sanierung.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class SanierungComponent extends StepComponent implements AfterViewInit, OnInit, OnDestroy {

  /**
   * sidebar element that should be fixed while scrolling
   */
  @ViewChild('sidebar') sidebar: ElementRef;

  /**
   * The components container
   */
  @ViewChild('container') container: ElementRef;

  /**
   * The sidebar container
   */
  @ViewChild('sidebarContainer') sidebarContainer: ElementRef;

  /**
   * The side button to be visible and fixed at some point while scrolling
   */
  @ViewChild('sideButton') sideButton: ElementRef;

  /**
   * The next steps container
   */
  @ViewChild('nextStepsContainer') nextStepsContainer: ElementRef;

  /**
   * Min Height of the sticky sidebar wrapper to avoid overlapping content
   */
  sidebarMinHeight: number = 0;

  /**
   * vertical offset for the sidebar while scrolling
   */
  sidebarOffset: number = 0;

  /**
   * vertical offset for the side button while scrolling
   */
  sideButtonOffset: number = 0;

  /**
   * Startpoint of the sidebar
   */
  sidebarInitialOffset: number = 0;

  /**
   * Startpoint of the side button
   */
  sideButtonInitialOffset: number = 0;

  private resizeObserver: ResizeObserver;

  // fallback for browsers without ResizeObserver
  private resizeFallbackInterval: any;

  private containerHeight: number = 0;

  /**
   * (input) data of the user
   */
  anfrage: ModeratAnfrage;

  /**
   * Formgroup for holding all selection elements for the measures
   */
  form: UntypedFormGroup;

  /**
   * Formgroup for the financial input
   */
  financialForm: UntypedFormGroup;

  /**
   * Formgroup for the cost input of the measures input
   */
  costForm: UntypedFormGroup = new FormGroup({});

  /**
   * Introduction dialog
   */
  introduction: MatDialogRef<SanierungIntroductionComponent> = null;

  /**
   * saving data for the measure, holding also the configuration for recommendations and showing hinttexts
   */
  measureData: {[key: string]: ResultMeasure};

  /**
   * list of possible measures for the user
   */
  measures: {[key: string]: string[]} = {
    insulation: ['dach', 'geschossdecke', 'fassade', 'kellerdecke', 'fenster1', 'fenster2', 'passivhaus'],
    heating: ['erneuern', 'waermepumpe_luft', 'waermepumpe', 'waermepumpe_wasser', 'holzpellets', 'erdgas', 'fernwaerme', 'nicht_erneuern'],
    additional: ['photovoltaik', 'solarthermie', 'lueftung', 'automation']
  };

  /**
   * List of recommendations measures.
   */
  recommendations: string[];

  /**
   * Holds the calculated costs form the backend.
   */
  costs: ResultDataCosts;

  /**
   * Backend position names ('fenster_<Verglasungstyp>') that orderCosts() merges into 'fenster'.
   */
  fensterBackendPositions: {name: string, default: number}[] = [];

  /**
   * Eventemitter if the costs change
   */
  costsChanges: EventEmitter<CostChangesEmitter> = new EventEmitter<CostChangesEmitter>();

  /**
   * the one recommend heating measure.
   */
  recommendHeatingMeasure: string = null;

  /**
   * holds the calculated consumptions and the possible saving, based on the users selection
   */
  consumption: Consumption = {
    kwh: {current: 0, sanitized: 0, percent: 0, recommend: 0, needed: 0, deviation: ""},
    co2: {current: 0, sanitized: 0, percent: 0, recommend: 0}
  };

  /**
   * do we have consumption data or not
   */
  consumptionData: boolean = false;

  /**
   * textkey for the recommand section in the sidebar.
   */
  recommendTextkey = 'moderat.sanierung.recommendation.text';

  /**
   * placeholder for the recommendation text
   */
  recommendPlaceholders: {co2_current: string, co2_percent: string, co2_sanitized: string};

  /**
   * toggles the recommand setion.
   */
  showRecommandSection: boolean = false;

  /**
   * toggle for the reset button
   */
  showResetButton: boolean = false;

  /**
   * toggle for the first finanze expand panel
   */
  financeToggle: boolean = false;

  /**
   * Some toggles for showing/hiding elements.
   */
  toggle = {
    kids: false,
    funding: false,
    helpZuschuss: false,
    helpBankkredit: false,
    helpZinssatz: false,
    helpRate: false,
    helpRest: false,
    sideHelpFunding: false
  };

  /**
   * Holds the api error to show the user some feedback.
   */
  apiErrors: string[] = [];

  /**
   * Holds warnings that are sent from the measure API
   */
  apiWarnings: string[] = [];

  /**
   * the users path
   */
  path: string;

  /**
   * name of a case that we need for some texts. i.e. in the introduction overlay
   */
  savingCase: string;

  /**
   * scrolloffset if embeded
   */
  scrollOffset: number = 0;

  /**
   * HOlds the entry URL of the advisor
   */
  entryUrl: string;

  /**
   * URL for the back link
   */
  previousLink: string = null;


  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean = false;

  /**
   * data for the dialog registration in the first section.
   */
  dialogData: any = {};

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * toggles for hinding element
   */
  hideElements: {rut: boolean, for: boolean, faq: boolean, donate: boolean} = {rut: false, for: false, faq: false, donate: false};

  /**
   * topics for the faq element
   */
  faqTopics: string[] = [];

  /**
   * toggle for the reset button at the end of the page.
   */
  showResetRequestButton: boolean = false;

  /**
   * Selected finanicing of the user
   */
  financing: FinanzierungsTyp = 'foerderkredit';

  /**
   * toggle for extra credit
   */
  extraCreditPossible: boolean = false;

  /**
   * Toggle if a accordion panel is open or closed.
   */
  isPanelOpen: boolean = true;

  /**
   * Toggle if district teaser should be shown
   */
  showDistrictTeaser: boolean = false;

  /**
   * Toggle to show logo instead of badge in districh teaser
   */
  showDistrictTeaserLogo: boolean;

  /**
   * toggle to disable measure district heating (fernwärme) and color text and question mark icon in red
   */
  disableMeasureDistrictHeating: boolean;

  /**
   * Holds the result if district heating is available in the district area
   * possible values: ja / nein / perspektivisch / keine_adresse
   */
  fernwaermenetz: string;

  /**
   * possible income ranges, depending on the kinder selection
   */
  incomeRanges: {ja: string[], nein: string[]} = {
    ja: ['weniger_40000', '40000_bis_50000', '50000_bis_60000', '60000_bis_90000', 'ueber_90000'],
    nein: ['weniger_30000', '30000_bis_40000', '40000_bis_50000', '50000_bis_90000', 'ueber_90000']
  };

  /**
   * default einkommen value per kinder selection
   */
  incomeDefaults: {ja: string, nein: string} = {
    ja: '60000_bis_90000',
    nein: '50000_bis_90000'
  };

  /**
   * currently shown income range, switched by the kinder selection
   */
  incomeRange: string[] = this.incomeRanges.ja;

  /**
   * @inheritDoc
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param embedService
   * @param decimalPipe
   * @param dialog
   * @param portalService
   * @param energyMapService
   * @param cdr
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: ModeratRequestService,
              protected elementService: ElementService, private embedService: EmbedService, private decimalPipe: DecimalPipe,
              public dialog: MatDialog, private portalService: PortalService,
              protected energyMapService: EnergyMapService, private cdr: ChangeDetectorRef,
              private advisorEventService: AdvisorEventService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    this.anfrage = this.requestService.getAnfrage();
    this.form = new UntypedFormGroup({});

    if(this.anfrage.finanzierungsArt) {
      this.financing = this.anfrage.finanzierungsArt;
    }

    // init costform
    this.financialForm = new UntypedFormGroup({
      kinder: new UntypedFormControl(this.anfrage.finanzierungInput?.kinder ?? 'ja'),
      einkommen: new UntypedFormControl(this.anfrage.finanzierungInput?.einkommen ?? this.incomeDefaults.ja),
      zinssatz: new UntypedFormControl(this.anfrage.finanzierungInput?.zinssatz ?? 0),
      eigenkapital: new UntypedFormControl(this.anfrage.finanzierungInput?.eigenkapital ?? 0),
    });

    // show the income range matching the (restored) kinder selection
    this.updateIncomeRange();

    // sync the form default into the anfrage so the initial calculation
    // does not fall back to the backend default 'weniger_40000'
    this.anfrage.finanzierungInput = {
      ...this.anfrage.finanzierungInput,
      einkommen: this.financialForm.get('einkommen').value,
      kinder: this.financialForm.get('kinder').value
    };

    this.path = this.anfrage.getPath();
    this.initDialogData();

    // check if it is an internal portal
    this.internalPortal = this.portalService?.isInternalPortal();
    this.hideReportDownload = this.portalService?.getConfigAsBool('embed.newsletter.report.download');

    // some elements could be made hidden with the portal configuration
    for(const key of Object.keys(this.hideElements)) {
      this.hideElements[key] = parseInt(this.portalService.getConfig('moderat.hide.' + key), 10) === 1;
    }

    // show/dont show content in faq element
    this.updateFaqTopics();

    // should we force to see the dialog box
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');

    // show special teaser in district heating path
    this.showDistrictTeaser = (this.anfrage?.interesse === 'fernwaerme' || this.anfrage?.showStepAddress === true) && !this.portalService.getConfigAsBool('fernwaerme.disable.teaser.resultpage');
    // get the portal config to show / hide logo instead of badge in diestrict heating teaser
    this.showDistrictTeaserLogo = this.portalService?.getConfigAsBool('fernwaerme.enable.teaser.showlogo');
    // show the resetbutton
    this.showResetRequestButton = this.portalService.getConfigAsBool('moderat.enable.resetrequest');

    // we reset value fernwaermenetz in anfrage if we are not in the district heating path
    if (this.anfrage.interesse !== 'fernwaerme' && !this.anfrage.showStepAddress && this.anfrage.verbrauchsanalyseInput?.fernwaermenetz) {
      this.anfrage.verbrauchsanalyseInput = {...this.anfrage.verbrauchsanalyseInput, fernwaermenetz: null};
      this.requestService.setAnfrage(this.anfrage);
    }
    // address-only path: force district heating check before massnahmen() to ensure valid recommendReason in measures
    this.fernwaermenetz = this.anfrage?.verbrauchsanalyseInput?.fernwaermenetz;
    if(this.anfrage.showStepAddress && this.anfrage.interesse !== 'fernwaerme'
      && !this.fernwaermenetz) {
      this.requestService.ensureDistrictHeatingStatus().subscribe(() => this.loadMassnahmen());
    }
    else {
      this.loadMassnahmen();
    }

    // get the scrolloffset if we are embeded
    if(this.embedService.isEmbedded()) {
      this.subscriptions.push(this.embedService.scrollEvent.subscribe(data => this.scrollOffset = data.offset));
    }

    // set the entry Url of the advisor
    this.entryUrl = this.portalService.currentPortalId + '/moderat';

    if (this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK) {
      this.previousLink = '../../wpcheck/verbrauchsdaten';
    }
    else if (this.energyMapService.showEnergyMap(this.anfrage, 'moderat') === true
      && this.energyMapService.isEnergyMapDataDonated(this.anfrage) === false
      && this.energyMapService.getEnergyMapConfirmDonation(this.anfrage) !== 'n'
      && this.energyMapService.getEnergyMapBuildingNotIncludedInMap(this.anfrage) !== true
    ) {
      this.previousLink = '../../bestandsaufnahme/energy-map';
    }
    else {
      this.previousLink = '../../bestandsaufnahme/daemmung/3';
    }

    // show navigation element back to the wpcheck
    if(this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK) {
      this.stepService.setNavigationPreElement(
        new StepNavigationElement('moderat.nav.wpcheck.', true,
          WpcheckStartComponent.wpcheckUrl.replace('{{portalId}}', this.portalService.currentPortalId))
      );
    }
  }

  /**
   * loads/(re)calculates the measures from the backend for the initial page load. Called either
   * directly from ngOnInit(), or - if the district heating status still has to be caught up for
   * this request - after that check has resolved (see ngOnInit()).
   */
  private loadMassnahmen(): void {
    this.loading = true;
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // calculate recommend meaures initially
      const resetDemand = Object.keys(this.anfrage.massnahmen ?? {}).length === 0;

      this.requestService.backendService.massnahmen(this.anfrage, requestId, resetDemand).subscribe(data => {
        this.anfrage.measureResult = data;

        // tell an embedding page that the result is reached
        if(data?.demand) {
          this.advisorEventService.result(requestId, data.hash ?? null);
        }

        this.orderMeasures();
        this.requestService.setAnfrage(this.anfrage);

        this.selectFinancing();

        this.extraCreditPossible = data.costs.einkommensbonus === true;

        // set current demand
        this.consumptionData = true;
        this.consumption.kwh.current = data.demand.kwh;
        this.consumption.kwh.needed = data.demand.kwh_bedarf;
        this.consumption.kwh.deviation = data.demand.abweichung_bedarf_einordnung;
        this.consumption.co2.current = data.demand.co2;
        this.consumption.kwh.recommend = data.recommend.kwh;
        this.consumption.co2.recommend = data.recommend.co2;
        this.recommendations = data.recommend.measures;

        this.measureData = data.measures;
        // check if we disable the radio button of the measure district heating
        this.disableMeasureDistrictHeating = data.measures?.fernwaerme?.recommendReason === 'spezifisch.fw_nein' && this.portalService.getConfigAsBool('fernwaerme.disable.measure.districtheating');
        this.costs = data.costs;
        this.orderCosts();

        // init costform AFTER orderCosts so merged positions (e.g. fenster) are used
        this.costForm = new UntypedFormGroup({});
        for(const position of this.costs.positions) {
          this.costForm.addControl(position.name, new UntypedFormControl(position.cost));
          this.costForm.get(position.name).addValidators([Validators.required, Validators.min(1)]);
        }

        this.costsChanges.emit({costs: this.costs, forceUpdate: false});
        this.initMeasureFormElements(this.measureData);

        // calculate saving
        this.recalculateSaving(data.saving);

        // calculate saving case
        this.setSavingCase();

        // warnings
        if(data.warnings && data.warnings.length > 0) {
          this.apiWarnings = data.warnings.map(warning => warning.code);
          this.showRecommandSection = true;
        }

        // check if we show the download module
        this.showDownload = !this.hideReportDownload && this.anfrage?.measureResult?.report && !this.internalPortal;

        // show the introduction with a little delay to leave time for scrolling
        setTimeout(() => this.showIntroduction(), 800);

        // update faq topics
        this.updateFaqTopics();

        // make sure this is the last step to to. Some components uses this for change detection
        this.loading = false;
      }, error => this.onApiError(error));
    });
  }

  /**
   * Is the donate teaser shown? Only for internal portals, can be hidden by the portal config.
   */
  get showDonate(): boolean {
    return this.internalPortal === true && this.hideElements.donate !== true;
  }

  /**
   * Is there anything to show in the section "next steps"? If not, the headline is hidden as well.
   */
  get showNextSteps(): boolean {
    return this.forceDialog || !!this.showDownload || this.showDistrictTeaser || this.faqTopics.length > 0
      || this.showDonate || PortalTeaserComponent.hasPortalTeaser();
  }

  /**
   * UPdate the FAQ topics based on portal settings and current funding sum
   */
  updateFaqTopics(): void {
    this.faqTopics = [];
    // the whole faq element can be hidden
    if(this.hideElements.faq === true) {
      return;
    }
    // show/dont show content in faq element
    if(this.hideElements.rut !== true) {
      this.faqTopics.push('planung', 'energieberatung');
    }
    if(this.hideElements.for !== true) {
      this.faqTopics.push('finanzierungsmittel');
    }
    if(this.internalPortal) {
      this.faqTopics.push('daemmen', 'erfahrungsaustausch');
    }
  }

  /**
   * (Re) order measures for the output to show the recommendations always on top.
   *
   */
  orderMeasures(): void {
    for (const measureSegment of Object.keys(this.measures)) {
      // set default order copy of measures for later comparison
      const defaultOrder = [...this.measures[measureSegment]];

      // sort measures depending on recommended or not
      this.measures[measureSegment].sort((measureA: string, measureB: string) => {
        const recommendA: ResultMeasure = this.anfrage.measureResult?.measures[measureA] ?? {};
        const recommendB: ResultMeasure = this.anfrage.measureResult?.measures[measureB] ?? {};

        // show recommended measures first
        if ((recommendA.recommend === true) !== (recommendB.recommend === true)) {
          return recommendA.recommend === true ? -1 : 1;
        }

        // show fossil based measures last
        if ((recommendA.recommendReason === 'fossil') !== (recommendB.recommendReason === 'fossil')) {
          return recommendA.recommendReason === 'fossil' ? 1 : -1;
        }

        // compare positions of measureA and measureB and set in default measure order
        const indexA = defaultOrder.indexOf(measureA);
        const indexB = defaultOrder.indexOf(measureB);

        return indexA - indexB;
      });
    }
  }

  /**
   * reorder the cost list and put the recommend elements on the top
   */
  orderCosts(): void {
    if (!this.costs?.positions || !this.measures) {
      return;
    }

    // Merge separat fentser positions into a single 'fenster' position so the user sees and edits one combined window cost instead of individual sub-positions.
    const fensterPositions = this.costs.positions.filter(position =>
      position.name.startsWith('fenster_')
    );

    if (fensterPositions.length >= 1) {
      // keep the real position names to translate a user edit back on submit
      this.fensterBackendPositions = fensterPositions.map(position => ({
        name: position.name,
        default: Number(position.default ?? position.cost ?? 0)
      }));

      // Accumulate the current costs (may include user-modified values)
      const totalCost = fensterPositions.reduce((sum, position) => sum + Number(position.cost || 0), 0);
      // Accumulate the backend defaults (used to detect whether the user has changed the value)
      const totalDefault = fensterPositions.reduce((sum, position) => sum + Number(position.default ?? position.cost ?? 0), 0);

      const mergedFenster = {
        name: 'fenster',
        cost: totalCost,
        default: totalDefault
      };

      // Replace all fenster_ sub-positions with the single merged position
      this.costs.positions = [
        ...this.costs.positions.filter(position => !position.name.startsWith('fenster_')),
        mergedFenster
      ];
    }
    else {
      // no fenster_ position active: nothing to translate on submit
      this.fensterBackendPositions = [];
    }

    // Erstelle eine flache Liste der Reihenfolge basierend auf this.measures
    const measureOrder: string[] = [];
    Object.keys(this.measures).forEach((key) => {
      const measureArray = this.measures[key];
      if(key === 'heating') {
        measureOrder.push('heizung');
        return;
      }
      measureOrder.push(...measureArray);
    });

    const mapName = (name: string) => {
      if(name.startsWith('heizung_')) {
        return 'heizung';
      }
      if(name === 'obergeschoss') {
         return 'geschossdecke';
      }
      if (name.startsWith('fenster_')) {
        return 'fenster';
      }
      return name;
    };

    // Sortiere die Kostenpositionen basierend auf der Reihenfolge von measureOrder
    this.costs.positions.sort((a, b) => {
      const indexA = measureOrder.indexOf(mapName(a.name));
      const indexB = measureOrder.indexOf(mapName(b.name));

      // Elemente, die nicht in measureOrder gefunden werden, kommen ans Ende
      if (indexA === -1) {
        return 1;
      }
      if (indexB === -1) {
        return -1;
      }

      return indexA - indexB;
    });

  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit() {
    super.ngAfterViewInit();

    // scroll to the top after init
    this.elementService.scrollToElement(
      document.querySelector('.' + StepNavigationComponent.STEPNAVIGATION_CLASS) || this.container.nativeElement);

    setTimeout(() => {
      this.initSidebarFirstPanelMinHeight();
      this.initOnWindowResize();

      if(this.embedService.isEmbedded()) {
        this.subscriptions.push(
          this.embedService.scrollEvent.subscribe(data => this.updateSidebarPosition(data))
        );
        this.subscriptions.push(
          this.embedService.scrollEvent.subscribe(data => this.updateButtonPosition(data))
        );
      }

      this.initSidebuttonOffset();
      this.initContainerResizeObserver();
    }, 500);
  }

  /**
   * Re-anchors the sidebar/side-button sticky offsets whenever content elsewhere on the
   * page (accordions, async widgets) changes the layout height after the initial render.
   */
  initContainerResizeObserver(): void {
    // document.body, not #container: costs-wrapper/#nextStepsContainer are its siblings,
    // and the component's own host element defaults to display:inline (unreliable for RO).
    const root = document.body;

    const reanchor = (height: number): void => {
      if(height === this.containerHeight) {
        return;
      }
      this.containerHeight = height;
      this.initSidebarOffset();
      this.initSidebuttonOffset();

      // re-render immediately; embedded mode self-corrects on the next relayed parent scroll
      if(!this.embedService.isEmbedded()) {
        this.updateSidebarPosition();
        this.updateButtonPosition();
      }
    };

    if(typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(entries => {
        if(entries.length > 0) {
          reanchor(entries[0].contentRect.height);
        }
      });
      this.resizeObserver.observe(root);
    }
    else {
      // fallback for older browsers without ResizeObserver
      this.resizeFallbackInterval = setInterval(() => {
        reanchor(root.offsetHeight);
      }, 500);
    }
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy(): void {
    super.ngOnDestroy();

    this.resizeObserver?.disconnect();
    clearInterval(this.resizeFallbackInterval);
  }

  /**
   * Initializes the minimum height of the sidebar's first panel.
   *
   * @return {void}
   */
  initSidebarFirstPanelMinHeight(): void {
    const sidebar = document.querySelector('.first-panel') as HTMLElement;
    this.sidebarMinHeight = sidebar?.offsetHeight;
  }

  /**
   * Basic error handling if the backend returns an invalid response.
   * @param result
   */
  onApiError(result: any) {
    if(result.error?.error && typeof result.error.error === "object" && result.error.error.map) {
      this.apiErrors = result.error.error.map(error => error.message);
    }
    else {
      this.apiErrors.push('moderat.sanierung.error.internal');
    }
  }

  /**
   * sets the savingcase for textoutput
   */
  setSavingCase(): void {
    if(this.anfrage.getPath() === ModeratAnfrage.PATH_EXPLO) {
      // explo path (show recommend measures)
      this.savingCase = 'none';
      if(this.consumption.kwh.percent < 0.75 && this.consumption.co2.percent < 0.75) {
        this.savingCase = 'high';
      }
      else if(this.consumption.kwh.percent > 0.75 && this.consumption.co2.percent < 0.75) {
        this.savingCase = 'high_co2';
      }
      else if(this.consumption.kwh.percent > 0.75 && this.consumption.co2.percent > 0.75 &&
        (this.consumption.kwh.percent < 1 || this.consumption.co2.percent < 1)) {
        this.savingCase = 'medium';
      }
    }
    else {
      // spezi path (preselected measures, selected by the user)
      this.savingCase = 'none';
      if(this.consumption.co2.recommend < this.consumption.co2.sanitized && this.consumption.co2.percent < 1) {
        this.savingCase = 'recommend';
      }
      else if(this.consumption.co2.recommend > this.consumption.co2.sanitized && this.consumption.co2.percent < 1) {
        this.savingCase = 'user';
      }
    }
  }

  /**
   * shows/opens the introduction overlay for the page
   *
   * @param force
   */
  showIntroduction(force: boolean = false): void {
    const unit = 'kwh';

    // remember the last case onad only show the overlay if the case changes
    let lastCase = null;
    try {
      if (typeof sessionStorage !== "undefined" && sessionStorage.getItem("mor-lastCase")) {
        lastCase = sessionStorage.getItem("mor-lastCase");
      }
    } catch (e) {

    }

    // if the possible saving is < 5%, do not show the overlay
    const deviation = this.consumption.kwh.sanitized / this.consumption.kwh.current;
    if (deviation > 0.95) {
      return;
    }

    if(force === true || lastCase !== this.savingCase) {
      try {
        if (typeof sessionStorage !== "undefined") {
          sessionStorage.setItem("mor-lastCase", this.savingCase);
        }
      } catch (e) {

      }

      // get energy source input and capitalize first letter (used in Overlay as placeholder)
      const energySourceInput = this.anfrage.verbrauchsanalyseInput.energietraeger_name;
      const energySource = energySourceInput.charAt(0).toUpperCase() + energySourceInput.slice(1);

      // build the config for the overlay
      const introductionConfig = {
        panelClass: 'sanierung-overlay',
        position: {
          top: (100 + (Math.min(0, this.scrollOffset) * -1)) + 'px',
        },
        data: {
          path: this.anfrage.getPath(),
          case: this.savingCase,
          current: this.consumption.kwh.current,
          needed: this.consumption.kwh.needed,
          deviation: this.consumption.kwh.deviation,
          energy_source: energySource,
          sanitized: this.consumption.kwh.sanitized,
          co2_current: this.consumption.co2.current,
          co2_sanitized: this.consumption.co2.sanitized,
          unit
        }
      };

      // set focus on first interactive element in dialog (here the close button)
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;

      // open the dialog
      this.introduction = this.dialog.open(SanierungIntroductionComponent, introductionConfig);
    }
  }

  /**
   * Updates the recommand text. This should be done with every measure selection change.
   */
  updateRecommendStatus(): void {
    this.recommendTextkey = 'moderat.sanierung.recommendation.text';
    this.showResetButton = false;
    // check if the user has made an own selection
    const hasMeasureChanged = Object.keys(this.measureData).filter(
      key => this.measureData[key].selected === true && !this.recommendations.includes(key) ||
        this.measureData[key].selected === false && this.recommendations.includes(key)
    ).length > 0;

    if(this.consumption.co2.recommend < this.consumption.co2.sanitized) {
      this.recommendTextkey = 'moderat.sanierung.recommendation.mehrco2';
      this.showRecommandSection = true;
      this.showResetButton = true;
    }
    else if(this.consumption.co2.sanitized < this.consumption.co2.recommend ||
      (hasMeasureChanged && this.consumption.co2.sanitized === this.consumption.co2.recommend)) {
      this.recommendTextkey = 'moderat.sanierung.recommendation.userwahl';
      this.showRecommandSection = true;
      this.showResetButton = true;
    }
    else if(this.consumption.co2.sanitized > this.consumption.co2.current) {
      this.recommendTextkey = 'moderat.sanierung.recommendation.steigerung';
      this.showRecommandSection = true;
      this.showResetButton = true;
    }
    // build placeholders for recommend text
    this.recommendPlaceholders = {
      co2_current: this.decimalPipe.transform(this.consumption.co2.current * 1, '1.0-1'),
      co2_sanitized: this.decimalPipe.transform(this.consumption.co2.sanitized * 1, '1.0-1'),
      co2_percent: this.getCo2Percent(),
     };
  }

  /**
   * calculate the (possible) co2 reduction if co2.current !== 0  and set placeholder co2_percent
   */
  getCo2Percent(): string {
    if(this.consumption?.co2.current === 0 || this.consumption?.co2.current === this.consumption?.co2.sanitized){
      return this.decimalPipe.transform(Math.round(this.consumption.co2.sanitized * 100), '1.0-0');
    }
    const reduction = 1 - (this.consumption.co2.sanitized / this.consumption.co2.current);
    const reductionPossible = 1 - (this.consumption.co2.recommend / this.consumption.co2.current);
    return this.decimalPipe.transform((reduction - reductionPossible) * -100, '1.0-0');
  }

  /**
   * resets the recommand selection to the initial settings
   */
  resetRecommandMeasures(): void {
    this.measures.insulation.forEach(name => {
      if(this.measureData.hasOwnProperty(name)) {
        this.form.get(name).setValue(this.recommendations.indexOf(name) > -1, {onlySelf: true});
      }
    });

    // add heating measures
    this.recommendHeatingMeasure = this.measures.heating.find(element => this.recommendations.indexOf(element) > -1);
    this.form.get('heating').setValue(this.recommendHeatingMeasure, {onlySelf: true});

    // add additional measures
    this.measures.additional.forEach(name => {
      if(this.measureData.hasOwnProperty(name)) {
        this.form.get(name).setValue(this.recommendations.indexOf(name) > -1, {onlySelf: true});
      }
    });

    // update calculation with resettet selection
    this.onMeasureSelectionChange(true);
  }

  /**
   * initialize the form for the measures
   * @param data
   */
  initMeasureFormElements(data: {[key: string]: ResultMeasure}): void {
    // add insulation measures
    this.measures.insulation.forEach(name => {
      if(data.hasOwnProperty(name)) {
        this.form.addControl(name, new UntypedFormControl(data[name].selected));
      }
    });

    // add heating measures
    this.recommendHeatingMeasure = this.measures.heating.find(element => data[element]?.selected);
    this.form.addControl('heating', new UntypedFormControl(this.recommendHeatingMeasure));

    // add additional measures
    this.measures.additional.forEach(name => {
      if(data.hasOwnProperty(name)) {
        this.form.addControl(name, new UntypedFormControl(data[name].selected));
      }
    });

    // subscribe to value changes of the form
    this.subscriptions.push(this.form.valueChanges.subscribe(() => this.onMeasureSelectionChange(true)));
  }

  /**
   * sets the income range matching the current kinder selection
   */
  updateIncomeRange(): void {
    this.incomeRange = this.incomeRanges[this.financialForm.get('kinder').value] ?? this.incomeRanges.ja;
  }

  /**
   * eventhandler if the user changes the kinder selection. Switches the income range and
   * resets the einkommen selection if the current value is not available in the new range.
   */
  onKinderChange(): void {
    this.updateIncomeRange();

    // keep a preselected value if it is still available in the new range,
    // otherwise fall back to the default of the current kinder selection
    if(!this.incomeRange.includes(this.financialForm.get('einkommen').value)) {
      const kinder = this.financialForm.get('kinder').value;
      this.financialForm.get('einkommen').setValue(this.incomeDefaults[kinder] ?? this.incomeDefaults.ja);
    }

    this.onMeasureSelectionChange(false);
  }

  /**
   * Translates the merged 'fenster' UI key in back to the real backend position name(s) e.g. 'fenster_einfach', 'fenster_zweifachverbund' before sending.
   */
  expandFensterCosts(costs: {[key: string]: number}): {[key: string]: number} {
    // nothing to translate: no 'fenster' key, or no known backend position for it
    if (!costs || !('fenster' in costs) || this.fensterBackendPositions.length === 0) {
      return costs;
    }

    const expanded = {...costs};
    const fensterValue = expanded['fenster'];
    delete expanded['fenster'];

    // single window type: same value, real key
    if (this.fensterBackendPositions.length === 1) {
      expanded[this.fensterBackendPositions[0].name] = fensterValue;
    }
    // two window types share the field: split by their default cost ratio
    else {
      const totalDefault = this.fensterBackendPositions.reduce((sum, position) => sum + position.default, 0);
      this.fensterBackendPositions.forEach(position => {
        const ratio = totalDefault > 0 ? position.default / totalDefault : 1 / this.fensterBackendPositions.length;
        expanded[position.name] = Math.round(fensterValue * ratio);
      });
    }

    return expanded;
  }

  /**
   * eventhandler if the user changes the selection of the measures
   */
  onMeasureSelectionChange(measureChange: boolean = true): void {
    this.apiErrors = [];
    this.apiWarnings = [];
    this.anfrage.massnahmen = this.form.getRawValue();

        // build financial data
    this.anfrage.finanzierungInput = {};
    this.anfrage.finanzierungInput.kinder = this.financialForm.get('kinder').value;
    this.anfrage.finanzierungInput.einkommen = this.financialForm.get('einkommen').value;
    this.anfrage.finanzierungInput.zinssatz = parseFloat(this.financialForm.get('zinssatz').value);
    this.anfrage.finanzierungInput.eigenkapital = parseFloat(this.financialForm.get('eigenkapital').value);

    // build cost data for positions and filter all null values.
    if(measureChange === true) {
      this.anfrage.resetMeasureSelectionAndCosts(false);
    }
    else {
      this.anfrage.massnahmenKosten = this.expandFensterCosts(this.costForm.getRawValue());
      for (const key in this.anfrage.massnahmenKosten) {
        if (this.anfrage.massnahmenKosten[key] === null) {
          delete this.anfrage.massnahmenKosten[key];
        }
      }
    }

    // recalcualte the costs
    this.consumptionData = false;
    this.loading = true;
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // recalculate measures
      this.requestService.backendService.massnahmen(this.anfrage, requestId, false).subscribe(data => {
        // force changedetection. Not clear why but the slider does not work properly without
        this.cdr.detectChanges();
        this.anfrage.measureResult = data;
        this.selectFinancing();

        this.consumptionData = true;
        this.measureData = data.measures;
        this.costs = data.costs;
        this.extraCreditPossible = data.costs.einkommensbonus === true;
        this.orderCosts();
        this.recalculateSaving(data.saving);

        for(const position of this.costs.positions) {
          if(this.costForm.get(position.name)) {
            this.costForm.get(position.name).setValue(position.cost);
          }
          else {
            this.costForm.addControl(position.name, new UntypedFormControl(position.cost));
            this.costForm.get(position.name).addValidators([Validators.required, Validators.min(1)]);
          }
        }

        // Remove any controls from the form that are not part of the current cost positions
        if (this.costForm && this.costs?.positions) {
          const validNames = new Set(this.costs.positions.map(p => p.name));
          Object.keys(this.costForm.controls).forEach(controlName => {
            if (!validNames.has(controlName)) {
              this.costForm.removeControl(controlName);
            }
          });
        }

        // When only costs changed (not measure selection), restore the user's custom values.
        // The backend doesn't understand merged keys like 'fenster' and returns backend defaults,
        // so we need to put the user's values back into the form after the update.
        if (!measureChange && this.anfrage.massnahmenKosten) {
          for (const [name, value] of Object.entries(this.anfrage.massnahmenKosten)) {
            if (value !== null && this.costForm.get(name)) {
              this.costForm.get(name).setValue(value, { emitEvent: false });
              // Also sync costs.positions so updateModifiedFields() sees cost !== default and shows the star
              const position = this.costs.positions.find(p => p.name === name);
              if (position) {
                position.cost = value as number;
              }
            }
          }
        }

        this.costsChanges.emit({costs: this.costs, forceUpdate: measureChange});

        // warnings
        if(data.warnings && data.warnings.length > 0) {
          this.apiWarnings = data.warnings.map(warning => warning.code);
          this.showRecommandSection = true;
        }

        // update faq topics
        this.updateFaqTopics();

        // make sure this is the last step to to. Some components uses this for change detection
        this.loading = false;
      }, error => {
        this.consumptionData = true;
        this.onApiError(error);
      });
    });

    // save selection in localstorage
    this.requestService.setAnfrage(this.anfrage);
  }

  /**
   * Select the current financing variant
   */
  selectFinancing(): void {
    if(!this.anfrage.measureResult.costs.financing?.foerderkredit) {
      // if no promotional loan available, use bankkredit
      this.financing = 'bankkredit';
    }
    else if(this.anfrage.finanzierungsArt) {
      // use the users selection
      this.financing = this.anfrage.finanzierungsArt;
    }
    else {
      // check which financing is the more cost efficiance
      if(this.anfrage.measureResult.costs.financing.foerderkredit.kreditrate_jahr <=
        this.anfrage.measureResult.costs.financing.bankkredit.kreditrate_jahr) {
        this.financing = 'foerderkredit';
      }
      else {
        this.financing = 'bankkredit';
      }
    }
  }

  /**
   * (re)calculate the consumption
   * @param data
   */
  recalculateSaving(data: any = null): void {
    // set the sanitized consumption to the current and reduce this with the single savings of each measure
    this.consumption.kwh.sanitized = data.kwh;
    this.consumption.co2.sanitized = data.co2;

    this.consumption.kwh.percent = this.consumption.kwh.sanitized / this.consumption.kwh.current;
    this.consumption.co2.percent = this.consumption.co2.sanitized / this.consumption.co2.current;

    // update the recommand text/status
    this.updateRecommendStatus();
  }

  /**
   * shows the financial details if the user clicks the details link.
   */
  showFinanceDetails(): void {
    this.financeToggle = true;

    this.elementService.scrollToElement(document.getElementById('finanzierung'));
  }

  /**
   * Methods called on each window resize automatically
   */
  @HostListener('window:resize')
  initOnWindowResize(): void {
    this.initSidebarOffset();
    this.initSidebuttonOffset();
  }

  /**
   * initialize the offset of the sticky sidebar. This is called on each window resize automatically
   */
  initSidebarOffset(): void {
    if(this.sidebar?.nativeElement) {
      this.sidebarInitialOffset = ElementService.getTopOffset(this.sidebar.nativeElement, 0) - this.sidebarOffset;

      if (this.embedService.isEmbedded()) {
        this.embedService.triggerFakeScroll();

        const stickyHeader = this.portalService.getConfig('embed.stickyheader.mobile');
        if (stickyHeader) {
          this.sidebarInitialOffset -= parseFloat(stickyHeader);
        }
      }
    }
  }

  /**
   * initialize the offset of the scroll to top button. This is called on each window resize automatically
   */
  initSidebuttonOffset(): void {
    if(this.sideButton?.nativeElement && this.nextStepsContainer?.nativeElement) {
      // measure the un-offset container, not the button itself (avoids racing its own [style.top])
      this.sideButtonInitialOffset = ElementService.getTopOffset(this.nextStepsContainer.nativeElement, 0);

      if (this.embedService.isEmbedded()) {
        this.embedService.triggerFakeScroll();

        const stickyHeader = this.portalService.getConfig('embed.stickyheader.mobile');
        console.log("stickyHeader", stickyHeader);
        if (stickyHeader) {
          this.sideButtonInitialOffset -= parseFloat(stickyHeader);
        }
      }
    }
  }

  /**
   * Methods called on scrolling automatically
   *
   */
  @HostListener('window:scroll')
  updateOnWindowScroll(): void {
    this.updateSidebarPosition();
    this.updateButtonPosition();
  }

  /**
   * Update the vertical sidebar position. This is called on scrolling automatically
   * @param data
   */
  updateSidebarPosition(data: { position: number, offset: number } = null): void {
    // get current scroll Position
    const scrollPosition: number = data ? data.offset * -1 : window.scrollY;

    // calculate maximum scrolling position
    const elementHeight: number = this.sidebar.nativeElement.offsetHeight;
    const containerHeight: number = this.sidebarContainer.nativeElement.offsetHeight;
    const maxScroll = containerHeight - elementHeight - 20;

    if(elementHeight > window.innerHeight) {
      // stop here, we have a very small window
      return;
    }

    // set the needed offset
    const oldSidebarOffset = this.sidebarOffset;
    this.sidebarOffset = Math.max(0, Math.min(maxScroll, scrollPosition - this.sidebarInitialOffset));

    // init sidebutton offset again when sidebar is not fixed anymore
    if (oldSidebarOffset === 0 && this.sidebarOffset > 0) {
      setTimeout(() => this.initSidebuttonOffset(), 0);
    }

  }

  /**
   * Update the vertical position of the scroll to top button. This is called on scrolling automatically
   * @param data
   */
  updateButtonPosition(data: { position: number, offset: number } = null): void {
    // get current scroll Position
    const scrollPosition: number = data ? data.offset * -1 : window.scrollY;

    const buttonHeight: number = this.sideButton.nativeElement.offsetHeight;
    const nextStepsContainerHeight: number = this.nextStepsContainer.nativeElement.offsetHeight;
    const maxButtonScroll: number = nextStepsContainerHeight - buttonHeight;

    this.sideButtonOffset = Math.max(0, Math.min(maxButtonScroll, scrollPosition - this.sideButtonInitialOffset));
  }

  /**
   * some placeholders for error message
   */
  errorPlaceholder(): any {
    return {...this.anfrage.verbrauchsanalyseInput, ...this.anfrage.bestandsanalyseInput, ...{entryUrl: this.entryUrl}};
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId,
        bmOptinSource: window.location.href,
        doisource: 'moc',
      };
    });
  }

  /**
   * Function is called if the users registered for the dialog
   * @param result
   */
  dialogRegistered(result: string): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();
  }

  /**
   * Scroll to Top Button
   */
  scrollToTop() {
    this.embedService.scrollToTop();
    this.elementService.scrollToElement(this.container.nativeElement);
  }

  /**
   * Reset the request object in the browser and start a new session
   */
  resetRequest(): void {
    this.requestService.resetLocalStorage();
    this.requestService.backendService.resetRequestId();
  }

  /**
   * Remeber the new financial art
   * @param newValue
   */
  onFinancingChange(newValue: FinanzierungsTyp): void {
    this.financing = newValue;
    this.anfrage.finanzierungsArt = newValue;

    this.requestService.setAnfrage(this.anfrage);
    this.requestService.saveDataToServer();
  }


  /**
   * Toggles the state of the panel when it is clicked.
   * @return {void}
   */
  onPanelClick(): void {
    this.isPanelOpen = !this.isPanelOpen;
  }

}
